import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateGroupRes;
export const addUpdateGroupTodo = createAsyncThunk('addUpdateGroup', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/add_update_group',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "group_id": data.id,
                "group_name": data.group,
                "status": data.status,
                "created_by": user_id.vemp_code,
                "new_user_ids": data.employee,
                "old_user_ids": data.old_employee,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateGroupRes = res.data
    } catch (error) {
        return addUpdateGroupRes = error.response.data
    }
})